<div class="scroll-buttons" aria-hidden="false">
    <button
        type="button"
        class="scroll-buttons__btn scroll-buttons__btn--top"
        [class.is-visible]="showTopButton"
        (click)="scrollToTop()"
        aria-label="Scroll to top"
        title="Scroll to top">
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M12 19V5M5 12l7-7 7 7"/>
        </svg>
    </button>

    <button
        type="button"
        class="scroll-buttons__btn scroll-buttons__btn--bottom"
        [class.is-visible]="showBottomButton"
        (click)="scrollToBottom()"
        aria-label="Scroll to bottom"
        title="Scroll to bottom">
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M12 5v14M5 12l7 7 7-7"/>
        </svg>
    </button>
</div>
